import {intlShape, utils} from '@wallaby-ui/core';
import PropTypes from 'prop-types';
import * as React from 'react';
import {defineMessages, injectIntl} from 'react-intl';

import styles from './AuditLogEventFormatter.less';
import LinkFormatter from './LinkFormatter';

const CASE_ID = 'caseId';
const DOCUMENT_ID = 'documentId';
const FILTER = 'filter';
const NAME = 'name';
const REPORT_SET = 'reportSet';
const EVENT = '_event';

const EVENTS_WITHOUT_CASE_LNIKS = [
  // 'LOAD_MINISCREEN',
  // 'UPDATE_MINISCREEN',
  // 'DELETE_MINISCREEN',
  'CASE_SHOW_OUTPATIENT',
  'CASE_SHOW_LABORATORY',
];

const I18N = defineMessages({
  AUDITLOG_CASE_DETAIL: {
    id: 'hai.reports.report.auditlogTable.caseDetail',
    defaultMessage: 'Detail',
  },
  AUDITLOG_DOCUMENT_DETAIL: {
    id: 'hai.reports.report.auditlogTable.caseDetail',
    defaultMessage: 'Detail',
  },
  AUDITLOG_FILTER_DETAIL: {
    id: 'hai.reports.report.auditlogTable.filterDetail',
    defaultMessage: 'Filter',
  },
  AUDITLOG_REPORT_DETAIL: {
    id: 'hai.reports.report.auditlogTable.reportDetail',
    defaultMessage: 'Report',
  },
});

class AuditLogEventFormatter extends React.PureComponent {
  render() {
    const {intl, value} = this.props;
    const eventData = JSON.parse(value);
    if (eventData) {
      const caseId = eventData[CASE_ID];
      const documentId = eventData[DOCUMENT_ID];
      const filter = eventData[FILTER];
      const reportSet = eventData[REPORT_SET];
      const eventType = eventData[EVENT];
      let name = '';
      if (eventData[NAME]) {
        name = utils.TranslateUtils.hasTranslation(eventData[NAME], intl)
          ? `${utils.TranslateUtils.translate({id: eventData[NAME]}, intl)} `
          : `${eventData[NAME]} `;
      }
      return (
        <div className={styles.dlAuditLogEventFormatter}>
          {caseId && (
            <div className={styles.dlDetailWrapper}>
              <span className={styles.dlAuditLogEventTitle}>
                {utils.TranslateUtils.translate(
                  I18N.AUDITLOG_CASE_DETAIL,
                  intl
                )}
                {':'}
              </span>
              {EVENTS_WITHOUT_CASE_LNIKS.includes(eventType) ? (
                <span title={`${name}[${caseId}]`}>{`${name}[${caseId}]`}</span>
              ) : (
                <LinkFormatter
                  route={'/case'}
                  searchParams={{docId: documentId}}
                  value={caseId}
                  text={`${name}[${caseId}]`}
                  useValue
                />
              )}
            </div>
          )}
          {!caseId && documentId && (
            <div className={styles.dlDetailWrapper}>
              <span className={styles.dlAuditLogEventTitle}>
                {utils.TranslateUtils.translate(
                  I18N.AUDITLOG_DOCUMENT_DETAIL,
                  intl
                )}
                {':'}
              </span>
              <LinkFormatter
                route={'/document'}
                value={documentId}
                text={`${name}[${documentId}]`}
                useValue
              />
            </div>
          )}
          {filter && (
            <div className={styles.dlDetailWrapper}>
              <span className={styles.dlAuditLogEventTitle}>
                {utils.TranslateUtils.translate(
                  I18N.AUDITLOG_FILTER_DETAIL,
                  intl
                )}
                {':'}
              </span>
              <span title={filter}>{filter}</span>
            </div>
          )}
          {reportSet && (
            <div className={styles.dlDetailWrapper}>
              <span className={styles.dlAuditLogEventTitle}>
                {utils.TranslateUtils.translate(
                  I18N.AUDITLOG_REPORT_DETAIL,
                  intl
                )}
                {':'}
              </span>
              <span
                title={utils.TranslateUtils.translate(
                  {
                    id: `hai.reports.report.auditlogTable.report.${reportSet}`,
                  },
                  intl
                )}
              >
                {utils.TranslateUtils.translate(
                  {
                    id: `hai.reports.report.auditlogTable.report.${reportSet}`,
                  },
                  intl
                )}
              </span>
            </div>
          )}
        </div>
      );
    }
    return '';
  }
}

AuditLogEventFormatter.displayName = 'AuditLogEventFormatter';

AuditLogEventFormatter.propTypes = {
  intl: intlShape.isRequired,
  value: PropTypes.string,
};

AuditLogEventFormatter.defaultProps = {
  value: undefined,
};

export default injectIntl(AuditLogEventFormatter);
